import { Spinner } from '@chakra-ui/react'
import { useParams } from 'react-router'
import { httpStatus } from 'src/constants/statusCodes'
import { useQuery } from 'src/hooks/use-query'
import { GetTrialHospitalSharedFileDocument } from 'src/lib/gql-client'
import { useGqlQuerySWRNoSuspense } from 'src/lib/gql-client/request'

import { ForbiddenMessageScreen } from './ForbiddenMessageScreen'
import { NotFoundMessageScreen } from './NotFoundMessageScreen'

type Params = {
  trialHospitalSharedFileUid: string
}

export const HospitalSharedFileViewer: React.FC = () => {
  const query = useQuery()
  const { trialHospitalSharedFileUid = '' as string } = useParams<Params>()
  const isDownload = query.get('download') === 'true'

  const { data, error } = useGqlQuerySWRNoSuspense(
    GetTrialHospitalSharedFileDocument,
    {
      trialHospitalSharedFileUid,
      uploadedFileUrlMode: isDownload ? 'Attachment' : 'Inline',
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
    },
  )

  if (error?.status === httpStatus.Forbidden) {
    return <ForbiddenMessageScreen />
  }

  if (error?.status === httpStatus.NotFound) {
    return <NotFoundMessageScreen />
  }

  if (!data) {
    return <Spinner />
  }

  const sharedUrl = data.trialHospitalSharedFile.uploadedFile.url

  if (isDownload) {
    window.location.href = sharedUrl
    return null
  }

  return <iframe src={sharedUrl} width="100%" height="100%" />
}
